import zhTW from 'ant-design-vue/es/locale/zh_TW';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';

// 設定 dayjs 為繁體中文
dayjs.locale('zh-tw');

// 創建自定義繁體中文本地化配置
const customLocale = {
  ...zhTW,
  DatePicker: {
    ...zhTW.DatePicker,
    lang: {
      ...zhTW.DatePicker.lang,
      // 自定義月份名稱為繁體中文格式
      monthFormat: 'M月',
      shortMonths: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
      weekDays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      placeholder: '請選擇日期',
      rangePlaceholder: ['開始日期', '結束日期'],
      yearFormat: 'YYYY年',
      monthSelect: '選擇月份',
      yearSelect: '選擇年份',
      previousMonth: '上個月',
      nextMonth: '下個月',
      previousYear: '上一年',
      nextYear: '下一年',
      today: '今天',
      now: '此刻',
      backToToday: '返回今天',
      ok: '確定',
      clear: '清除',
      month: '月',
      year: '年',
      timeSelect: '選擇時間',
      dateSelect: '選擇日期',
      monthSelect: '選擇月份',
      yearSelect: '選擇年份',
      decadeSelect: '選擇年代',
      // 日期範圍快捷選項
      ranges: {
        '今天': '今天',
        '昨天': '昨天',
        '本月': '本月',
        '上個月': '上個月',
        '半年': '半年',
        '一年': '一年'
      }
    }
  }
};

export default customLocale;